import axios from "axios";
import { baseApiUrl, getHttpHeaders, getHttpHeadersExcel, httpRequest } from "./ApiUtils";

const followUpEventApiUrl = `${baseApiUrl}/api/FollowUpEvents`;

export async function getFollowUpEventList(
    pageNumber,
    pageSize,
    orderBy,
    isFor,
    isFirstYear,
    status,
    contractTypeId,
    primaveraDepartmentId,
    yearToBeApplied
) {
    return await httpRequest(
        fetchFollowUpEventList.bind(
            this,
            pageNumber,
            pageSize,
            orderBy,
            isFor,
            isFirstYear,
            status,
            contractTypeId,
            primaveraDepartmentId,
            yearToBeApplied
        )
    );
}
async function fetchFollowUpEventList(
    pageNumber,
    pageSize,
    orderBy,
    isFor,
    isFirstYear,
    status,
    contractTypeId,
    primaveraDepartmentId,
    yearToBeApplied
) {
    let config = getHttpHeaders();
    let url = `${followUpEventApiUrl}?`;
    if (isFor !== undefined) {
        url = url.concat(`isFor=${isFor}&`);
    }
    if (isFirstYear !== undefined) {
        url = url.concat(`isFirstYear=${isFirstYear}&`);
    }
    if (status !== undefined) {
        url = url.concat(`status=${status}&`);
    }
    if (contractTypeId !== undefined) {
        url = url.concat(`contractTypeId=${contractTypeId}&`);
    }
    if (primaveraDepartmentId !== undefined) {
        url = url.concat(`primaveraDepartmentId=${primaveraDepartmentId}&`);
    }
    if (yearToBeApplied !== undefined) {
        url = url.concat(`yearToBeApplied=${yearToBeApplied}&`);
    }
    return await axios.get(
        `${url}OrderBy=${orderBy}&PageNumber=${pageNumber}&PageSize=${pageSize}`,
        config
    );
}

export const updateFollowUpEvent = async (data) => {
    return await httpRequest(putFollowUpEvent.bind(this, data));
};

const putFollowUpEvent = async (data) => {
    let config = getHttpHeaders();
    return await axios.put(`${followUpEventApiUrl}`, data, config);
};

export async function getDoneEventsReport(startDate, endDate) {
    return await httpRequest(fetchgetDoneEventsReport.bind(this, startDate, endDate));
}
async function fetchgetDoneEventsReport(startDate, endDate) {
    let config = getHttpHeadersExcel();
    return await axios.get(`${followUpEventApiUrl}/DoneEventsReport?startDate=${startDate}&endDate=${endDate}`, config);
}


export async function getDoneEventsReportBEE(startDate, endDate) {
    return await httpRequest(fetchgetDoneEventsReportBEE.bind(this, startDate, endDate));
}
async function fetchgetDoneEventsReportBEE(startDate, endDate) {
    let config = getHttpHeadersExcel();
    return await axios.get(`${followUpEventApiUrl}/DoneEventsReportBEE?startDate=${startDate}&endDate=${endDate}`, config);
}


export async function getFollowUpEventYearToBeAppliedList() {
    return await httpRequest(fetchFollowUpEventYearToBeAppliedList.bind(this));
}
async function fetchFollowUpEventYearToBeAppliedList() {
    let config = getHttpHeaders();
    return await axios.get(`${followUpEventApiUrl}/GetFollowUpEventYearToBeAppliedList`, config);
}